import * as BUNDLE from "./all.js";

import { use } from "./chain.js";

use(BUNDLE);

export default BUNDLE;